<cc-user-header
  [title]="title"
  [subtitle]="subtitle"
  [userCount]="projectUsersTotalCount"
  [learnMoreLink]="learnMoreLink"
>
  <cc-banner
    *ngIf="domainNotDefinedBanner && !isLoadingBanner"
    type="warning"
    icon="warning"
    alignment="center"
    width="fit-content"
    bannerText="Visitor users cannot be added because a domain is not defined in your workspace settings."
    data-test="visitor-user-warning-banner"
  >
    <a
      href="https://intercom.help/dashpivot/en/articles/6761341-dashpivot-visitors"
      target="_blank"
      rel="noopener noreferrer"
      class="sm-text-default-blue sm-underline"
      data-test="learn-more-visitor-users"
      i18n
    >
      Learn more
    </a></cc-banner
  >
  <cc-banner
    *ngIf="visitorsNotAllowedBanner && !isLoadingBanner"
    data-test="visitor-user-plan-type-banner"
    type="warning"
    icon="warning"
    alignment="center"
    width="fit-content"
    bannerText="Visitor users are not included on the Standard Plan: "
  >
    <button class="sm-text-default-blue sm-underline" (click)="openUpgradeModalVisitorUsers()">
      {{ upgradePlanMessage }}
    </button>
  </cc-banner>
  <cc-user-invite
    *ngIf="showUserInviteComponent"
    [model]="projectUserModel"
    [userType]="folderUserType"
    (inviteUser)="onInviteProjectMember()"
  ></cc-user-invite>
</cc-user-header>

<cc-banner
  *ngIf="ssoFeatureMessage?.message && folderUserType === userTypes.Contributor"
  data-test="sso-banner-project"
  type="info"
  icon="info"
  showBadge="true"
  badgeText="New"
  dismissible="true"
  alignment="center"
  width="fit-content"
  ccBannerLogic
  [bannerKey]="bannerKey"
  [bannerText]="ssoFeatureMessage.message"
  [localStorageKey]="bannerStorageKey"
>
  <button
    *ngIf="ssoFeatureMessage.showUpgrade"
    data-test="upgrade-plan-button"
    class="sm-text-default-dark-blue sm-underline"
    (click)="openUpgradeModalSSO()"
  >
    {{ upgradePlanMessage }}
  </button>
  <a
    *ngIf="!ssoFeatureMessage.showUpgrade"
    href="https://intercom.help/dashpivot/en/articles/8133878-how-to-setup-single-sign-on-sso"
    target="_blank"
    rel="noopener noreferrer"
    class="sm-text-default-dark-blue sm-underline"
    data-test="sso-learn-more"
    i18n
  >
    Learn more
  </a>
</cc-banner>

<cc-user-list
  [userList]="projectUsers"
  [userType]="folderUserType"
  [isLoading]="isLoading"
  [canEditProfile]="canEditProfile"
  [canRemoveUser]="canInviteOrRemoveProjectUser"
  [currentUserId]="currentUserId"
  [permissionOptions]="projectPermissions"
  [hasCurrentOrSubFoldersToggle]="true"
  (refreshUsers)="refreshProjectUsers()"
  (remove)="onRemoveProjectUser($event)"
  (onUpdateTabView)="onUpdateTabView($event)"
></cc-user-list>
